import { RealEstateAgent } from 'schema-dts';
import { Agent } from '../../domain/graphcms';

export function getAgentStructuredData(
  agent: Agent,
  canonical: string,
): RealEstateAgent {
  const data: RealEstateAgent = {
    '@type': 'RealEstateAgent',
    name: `${agent.name} ${agent.surname}`,
    telephone: '0287178289',
    memberOf: {
      '@type': 'Organization',
      name: 'Dove.it',
      logo: 'https://cdn.dove.it/static/assets/logo.png',
      taxID: 'P.IVA 10461690967',
      areaServed: agent.area,
      url: canonical,
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '0287178289',
        email: 'info@dove.it',
        contactType: 'Customer service',
      },
    },
  };

  if (agent.photo?.url) {
    data.image = agent.photo?.url;
  }

  return data;
}
